// src/utils/env.js
export const API_BASE = process.env.REACT_APP_API_BASE;
export const API_KEY  = process.env.REACT_APP_API_KEY;

if (!API_BASE || !API_KEY) {
  // eslint-disable-next-line no-console
  console.warn("[ENV] Missing REACT_APP_API_BASE or REACT_APP_API_KEY");
}

// Feature flag: admin-only per-user "view as" (analytics). OFF by default so it dark-ships
// completely inert — the picker doesn't render and no X-Acting-User header is ever set, so
// the app is byte-identical to today. Flip on (REACT_APP_FEATURE_VIEW_AS_USER=true) only once
// the rose-ai-modeler X-Acting-User read path is live and validated on dev.
export const FEATURE_VIEW_AS_USER = process.env.REACT_APP_FEATURE_VIEW_AS_USER === "true";